(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dw-product-template-compatible-products"] && !Shopify.designMode) return;
  try {
    const loadMoreButton = document.getElementById('compatible-load-more')

  const getHiddenCards = () =>
    document.querySelectorAll('#compatible-products-target compatible-card[hidden]')

  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', (e) => {
      const hiddenCards = getHiddenCards()
      if (!hiddenCards.length) {
        return
      }

      const cardsToShow = Array.from(hiddenCards).slice(0, loadMoreButton.dataset.loadMore);

      if (cardsToShow.length) {
        cardsToShow.forEach((el) => el.hidden = false)
      }

      if (hiddenCards.length <= loadMoreButton.dataset.loadMore) {
        loadMoreButton.hidden = true
      }
    })
  }

  document.addEventListener('product:variantChange', async ({ detail: currentVariant }) => {
    const compatibleProducts = document.getElementById('compatible-products-target')

    if (compatibleProducts) {
      const response = await fetch(`${currentVariant.url}?variant=${currentVariant.id}&view=compatible`)
      compatibleProducts.innerHTML = await response.text()

      if (loadMoreButton) {
        const hiddenCards = getHiddenCards()
        loadMoreButton.hidden = hiddenCards.length ? false : true
      }
    }
  })
  } catch(e) { console.error(e); }
})();

})();
